import { cancel } from "../Helpers/ExecutionStatus";
import * as DomHelper from "../Helpers/DomHelper";
import * as BlobHelper from "../Helpers/BlobHelper";
import { headRequest } from "../Helpers/AjaxHelper";
const global = window;
const { selfHelp: { resources, manifestEndpoint } } = global;
const { statusIconVals } = DomHelper;
let diagnostics;
const key = "fetchManifest";
/** Ends tests. Updates DOM and Blob. Ensures that if tests have been canceled execution stops. */
function endTest() {
    if (cancel) {
        return;
    }
    DomHelper.createMoreDetailsSection(key, diagnostics.details);
    BlobHelper.updateBlob(key, diagnostics);
    diagnostics.success ? DomHelper.displayStatusIcon(key, statusIconVals.success) : DomHelper.displayStatusIcon(key, statusIconVals.error);
    DomHelper.makeBarGrow(key);
}
/**
 * Checks cache for manifest response data and returns it if it exists and is not expired.
 * If it does not exist, makes a new request for the manifest data and adds it to the cache.
 */
function retreiveManifestResponse() {
    let response;
    return headRequest(manifestEndpoint)
        .then((res) => {
        response = {
            name: "Manifest Data",
            uri: manifestEndpoint,
            status: res.status,
            statusText: res.statusText,
        };
        return response;
    })
        .catch((err) => {
        response = {
            name: "Manifest Data",
            uri: manifestEndpoint,
            status: err.status,
            statusText: err.statusText,
        };
        return response;
    });
}
/** Tries to grab the manifest data from the manifest endpoint obtained from the server */
async function runManifestDiagnostics() {
    if (cancel) {
        endTest();
    }
    if (!manifestEndpoint) {
        diagnostics = {
            success: false,
            details: resources.Manifest_noEndpoint,
        };
        endTest();
        return;
    }
    const response = await retreiveManifestResponse();
    const success = response.status >= 200 || response.status <= 400;
    const details = success ?
        resources.Manifest_success.replace("{0}", response.status) :
        resources.Manifest_failure;
    diagnostics = {
        success,
        status: response.status,
        statusText: response.statusText,
        details,
    };
    endTest();
}
/** Triggers beginning of test and update of DOM. */
export function startTest() {
    diagnostics = { success: null, details: null };
    DomHelper.displayStatusIcon(key, statusIconVals.inProgress);
    runManifestDiagnostics();
}
//# sourceMappingURL=ManifestDiagnostics.js.map